<template>
    <div style="background: #fff">
        <div class="navi">
            <div class="tabs">
                <div @click="switchTab(1)" :class="['tab',currentTab===1?'selected':'']">
                    <img v-if="currentTab===1" src="../../assets/img/iconEchart.svg" alt="">
                    今日金价
                </div>
                <div @click="switchTab(2)" :class="['tab',currentTab===2?'selected':'']">
                    <img v-if="currentTab===2" src="../../assets/img/iconCalculator.svg" alt="">
                    钻石计算器
                </div>
            </div>
        </div>
        <div :class="['Utilities', currentTab===1?'':'hidden']">
            <GoldPrice></GoldPrice>
        </div>
        <div :class="['Utilities', currentTab===2?'':'hidden']">
            <NewCalculator></NewCalculator>
        </div>
    </div>
</template>

<script>
import GoldPrice from './components/GoldPrice'
import NewCalculator from './components/NewCalculator'

export default {
    components: {
        GoldPrice,
        NewCalculator
    },
    data() {
        return {
            currentTab: 2
        }
    },
    created() {
        this.currentTab = this.$route.query.utilType * 1
    },
    methods: {
        switchTab(tabIndex){
            this.$router.replace(`/utilities?utilType=${tabIndex}`)
        },
    },
    watch: {
        '$route'() {
            this.currentTab = this.$route.query.utilType * 1
        }
    }
}
</script>

<style lang="scss">
.flex-center {
    display: flex;
    align-items: center;
}
.hidden{
    display: none;
}
.navi{
    background: url("../../assets/img/bgNavi.png") no-repeat;
    height: 73px;
    background-size: 100%;
    .tabs{
        display: flex;
        width: 66%;
        height: 100%;
        margin: auto;
        text-align: end;
        padding-top: 20px;
        font-size: 20px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        .tab{
            line-height: 23px;
            padding: 15px 30px;
            display: flex;
        }
        .selected{
            border-radius: 20px 20px 0 0;
            background: white;
            color: rgba(26, 26, 26, 1);
            img{
                width: 21px;
                margin-right: 10px;
            }
        }
    }
}
.Utilities {
    width:fit-content;
    margin: 0 auto 40px auto;
    min-height: 600px;
}
</style>